// Simple toast hook for notifications
import { useState, useCallback } from 'react'

export type ToastProps = {
  title: string
  description?: string
  variant?: 'default' | 'destructive'
}

type ToastState = ToastProps & {
  id: string
}

let toastCounter = 0
const listeners: ((toast: ToastState | null) => void)[] = []

export function useToast() {
  const [currentToast, setCurrentToast] = useState<ToastState | null>(null)

  // Subscribe to toast changes
  useState(() => {
    listeners.push(setCurrentToast)
    return () => {
      const index = listeners.indexOf(setCurrentToast)
      if (index > -1) {
        listeners.splice(index, 1)
      }
    }
  })

  const toast = useCallback((props: ToastProps) => {
    const id = `toast-${++toastCounter}`
    const newToast: ToastState = { ...props, id }

    // Notify all listeners
    listeners.forEach(listener => listener(newToast))

    // Auto dismiss after 5 seconds
    setTimeout(() => {
      listeners.forEach(listener => listener(null))
    }, 5000)

    return id
  }, [])

  return {
    toast,
    currentToast,
    dismiss: () => setCurrentToast(null),
  }
}
